module.exports = __webpack_public_path__ + "02e6b4fc06adc846dfa93359babe09ec.MP3";